import { createContext, useContext } from "react";

export const AppConfigContext = createContext();

export function useAppConfig() {
  const context = useContext(AppConfigContext);

  if (!context) {
    throw new Error('useAppConfig must be used inside AppConfigProvider');
  }
  return context;
}
